document.addEventListener('DOMContentLoaded', () => {
    const employeeCards = document.querySelectorAll('.mtt-employee-card')
    const filterButtons = document.querySelectorAll('.mtt-employees__filter button')
    const drownDownFilter = document.querySelector('#employee-dropdown')

    if (filterButtons.length > 0) {
        addEventListeners()
    }

    function showAllEmployees () {
        for (let index = 0; index < employeeCards.length; index++) {
            const employee = employeeCards[index]
            employee.classList.remove('hidden')
        }
    }

    function addEventListeners () {
        for (let index = 0; index < filterButtons.length; index++) {
            const button = filterButtons[index]

            button.addEventListener('click', () => {
                const termId = button.getAttribute('data-term-id')

                toggleEmployees(termId)
                removeActiveClasses()
                button.classList.add('active')
                drownDownFilter.value = termId
            })

            drownDownFilter.addEventListener('change', () => {
                filterDropdown()
            })
        }
    }

    function toggleEmployees (id) {
        if (parseInt(id) === 0) {
            showAllEmployees()
        } else {
            for (let i = 0; i < employeeCards.length; i++) {
                const employee = employeeCards[i]

                if (employee.getAttribute('data-term-id') === null) {
                    return
                }

                const areasArray = employee.getAttribute('data-term-id').split(',')

                if (areasArray.includes(id) === false) {
                    employee.classList.add('hidden')
                } else {
                    employee.classList.remove('hidden')
                }
            }
        }
    }

    function removeActiveClasses () {
        for (let index = 0; index < filterButtons.length; index++) {
            const button = filterButtons[index]
            button.classList.remove('active')
        }
    }

    function filterDropdown () {
        const termId = drownDownFilter.value
        const activeBtn = document.querySelector('.mtt-employees__filter button[data-term-id="' + termId + '"]')
        toggleEmployees(termId)
        removeActiveClasses()

        if (activeBtn) {
            activeBtn.classList.add('active')
        }
    }

});